import React, { useState, useEffect } from 'react';
import { images } from '../utils/mock';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <img
              src={images.logo}
              alt="Agente 360"
              className="h-12 w-auto cursor-pointer transition-transform duration-300 hover:scale-105"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('programa')}
              className="text-white/90 hover:text-orange-500 transition-colors duration-300 text-sm font-medium"
            >
              Programa
            </button>
            <button
              onClick={() => scrollToSection('modulos')}
              className="text-white/90 hover:text-orange-500 transition-colors duration-300 text-sm font-medium"
            >
              Módulos
            </button>
            <button
              onClick={() => scrollToSection('quien')}
              className="text-white/90 hover:text-orange-500 transition-colors duration-300 text-sm font-medium"
            >
              Quién Soy
            </button>
            <button
              onClick={() => scrollToSection('inversion')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-orange-500/50 hover:scale-105"
            >
              Inscríbete
            </button>
          </nav>

          <button
            onClick={() => scrollToSection('inversion')}
            className="md:hidden bg-gradient-to-r from-orange-500 to-orange-600 text-white px-5 py-2 rounded-full text-sm font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300"
          >
            Inscríbete
          </button>
        </div>
      </div>
    </header>
  );
};
